import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ClientActionsTypes, LoadClientsSuccess } from '../actions/client.action';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Injectable, inject } from '@angular/core';
import { PatientsService } from '@nrwl/rx-service-patients';

@Injectable()
export class PatientsEffects {
  private actions$ = inject(Actions);
  private patientsService = inject(PatientsService);

  LoadClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientActionsTypes.LoadClients),
      switchMap((action: any) => {
        return this.patientsService
          .getPatients()
          .pipe(map((res: any) => new LoadClientsSuccess(res)));
      }),
    ),
  );
}
